// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { ReferencesModule } from '../../shared/components/references/references.module';
import { SectorAirSummaryComponent } from './sector-air-summary.component';
import { DirectionsModule } from './components/directions.module';
import { TravelDateModule } from 'app_sasha/shared/components/travel-date/travel-date.module';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    declarations: [
        SectorAirSummaryComponent,
    ],
    imports: [
        CommonModule,
        ReferencesModule,
        DirectionsModule,
        TravelDateModule,
        FontAwesomeModule,
    ],
    exports: [
        SectorAirSummaryComponent,
    ],
})
export class SectorAirSummaryModule {}
